import { gql } from '@apollo/client';

export const upsertScheduledTimeOffMutation = gql`
  mutation upsertScheduledTimeOff($input: UpsertScheduledTimeOffInput!) {
    upsertScheduledTimeOff(input: $input) {
       conflicts {
          id
          startDateTimeInUTC
          startTime
          endTime
          endDateTimeInUTC
          staffAssignments
          event {
            id
            label
            code
            effectiveName
            startDate
            endDate
            datesOverrideText
            isDatesOverride
            ageRangeLabel
            endTime
            isTimesOverride
            startTime
            time
            timeLabel
            dateLabel
            isDaysOfTheWeekOverride
            weekdays
            location {
              id
              name
              city
              state
              zipcode
              address
            }
            franchise{
              id
              name 
              
            }
            program {
              id
              name
              color
            }
          }
        }
      success
      messages
    }
  }
`;
export const deleteScheduledTimeOffMutation = gql`
  mutation deleteScheduledTimeOff($input: ID!) {
    deleteScheduledTimeOff(input: $input) {
      success
    }
  }
`;


export const deleteScheduledTimeOffAsyncMutation = gql`
  mutation deleteScheduledTimeOffAsync($input: ID!) {
    deleteScheduledTimeOffAsync(input: $input) {
      id
    }
  }
`;

export const upsertScheduledTimeOffAsyncMutation = gql`
  mutation upsertScheduledTimeOffAsync($input: UpsertScheduledTimeOffInput!) {
    upsertScheduledTimeOffAsync(input: $input) {
      id
    }
  }
`;